"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _layout = require("../../layout");

var _context = require("../../context");

var _button = require("../../button");

var _propTypes = require("../../prop-types");

var _constants = require("./constants");

var _core = require("@emotion/core");

var PageHeaderButtonBase = (0, _context.styledWithTheme)(_button.Button)(function (_ref) {
  var theme = _ref.theme,
      paddingHorizontal = _ref.paddingHorizontal,
      hasHover = _ref.hasHover;
  return "\n  padding: 0 ".concat((0, _utils.px)(theme.selectors.space(paddingHorizontal) || paddingHorizontal), ";\n  height: 100%;\n  font-weight: ").concat(theme.selectors.fontWeight('regular'), ";\n\n  &:focus {\n    outline-offset: -2px;\n  }\n\n  &:hover {\n    ").concat(hasHover ? "background-color: ".concat(theme.selectors.color('primary'), ";") : '', "\n    text-decoration: none;\n  }\n");
});
var PageHeaderButtonDefaultProps = {
  paddingHorizontal: 'S300',
  hasHover: true
};

var PageHeaderButtonWithoutDocs = function PageHeaderButtonWithoutDocs(_ref2) {
  var icon = _ref2.icon,
      dataTestId = _ref2.dataTestId,
      _ref2$paddingHorizont = _ref2.paddingHorizontal,
      paddingHorizontal = _ref2$paddingHorizont === void 0 ? PageHeaderButtonDefaultProps.paddingHorizontal : _ref2$paddingHorizont,
      children = _ref2.children,
      hasIcon = _ref2.hasIcon,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref2, ["icon", "dataTestId", "paddingHorizontal", "children", "hasIcon"]);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeaderButton',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(PageHeaderButtonBase, (0, _extends2.default)({
    paddingHorizontal: paddingHorizontal,
    hasIcon: hasIcon || !!icon,
    iconOnly: !!icon && !children,
    inverseColor: _constants.PAGE_HEADER_BACKGROUND_COLOR,
    tertiary: true
  }, buttonProps, dataTestProps), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: "S100",
    height: "100%"
  }, !!icon && icon, !!children && children));
};

var PageHeaderButton = (0, _stencilReactDesc.describe)(PageHeaderButtonWithoutDocs).description('Button for page header.');
exports.PageHeaderButton = PageHeaderButton;
PageHeaderButton.displayName = 'PageHeaderButton';
PageHeaderButton.defaultProps = PageHeaderButtonDefaultProps;
PageHeaderButton.propTypes = {
  paddingHorizontal: (0, _propTypes.cssValue)().description('Sets the horizontal (left and right) padding.'),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon to the left side of the button.'),
  children: _stencilReactDesc.PropTypes.node.description('Content of the button.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};